import styled from 'styled-components';
import { theme } from '../../styles';

export const StyledMBTACallout = styled.div`
  .mbta-container {
    .image {
      max-width: unset !important;
    }
    .carouselControlType3b {
      .right-arrow,
      .left-arrow {
        background-color: transparent !important;
      }
      @media ${theme.mediaQuery.allMobiles} {
        div:nth-child(2) {
          display: flex;
          overflow: hidden;
          width : 90px
          position: relative;
        }
        div>button > * {
          flex: 0 0 30px;
        }
      }
    }

    .carousel-text {
      height: 152px;
    }
  }

  /* Base container styling */
  .container {
    padding: 50px 20px;
    font-family: Arial, sans-serif;
    text-align: center;
  }

  /* Header styling */
  .container .header {
    color: initial;
    text-align: start;
  }

  .custom-btn {
    margin-top: 1rem;
  }

  /* Grid layout for the experience cards */
  .container .experience-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr); /* 3 equal columns */
    gap: 30px;
    margin-top: 40px;
  }

  .container .experience-card {
    background-color: #fff; /* White background for cards */
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    padding: 0; /* No padding at the top */
    color: #333;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .container .experience-card .image-container {
    position: relative;
    aspect-ratio: 16 / 9;
    max-height: 364px;
    width: 100%;
    background-size: cover;
    background-position: center;
  }

  .container .experience-card .button {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #030919; /* Blue button background */
    color: white;
    text-decoration: none;
    padding: 10px 20px;
    font-weight: bold;
    text-transform: uppercase;
    display: inline-block;
  }

  .container .experience-card .button:hover {
    background-color: #030919; /* Darker blue on hover */
  }

  /* Card title and description styling */
  .container .experience-card .title {
    font-size: 22px;
    font-weight: bold;
    margin-top: 15px;
    margin-bottom: 10px;
    color: #212529 !important;
  }

  .container .experience-card .description {
    font-size: 16px;
    color: #666;
    margin-bottom: 20px;
  }

  /* Explore More button styling */
  .container .explore-button {
    display: inline-block;
    margin-top: 40px;
    padding: 12px 20px;
    background-color: #030919;
    color: white;
    text-decoration: none;
    border: 1px solid #ffffff;
    font-weight: bold;
    text-transform: uppercase;
  }

  .container .explore-button:hover {
    background-color: #030919 !important;
  }

  /* Responsive Design using Grid */
  @media (max-width: 768px) {
    .container .header {
      font-size: 28px; /* Smaller header for mobile */
    }

    .container .sub-header {
      font-size: 16px;
    }

    .container .experience-container {
      grid-template-columns: 1fr; /* 1 column on small screens */
    }

    .container .experience-card {
      width: 100%; /* Full-width cards on mobile */
      margin-bottom: 20px;
    }

    .container .experience-card .title {
      font-size: 18px;
    }

    .container .experience-card .description {
      font-size: 14px;
    }

    .container .explore-button {
      font-size: 14px;
    }
  }
`;
